import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=bd4df9a0&"
import script from "./ReceiptList.vue?vue&type=script&lang=js&"
export * from "./ReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VDialog,VIcon,VSpacer})
